import React from 'react';
import { Link } from 'react-router-dom';
import LegalDocumentLayout from './LegalDocumentLayout';

const TermsOfService = () => {
  return (
    <LegalDocumentLayout title="Terms of Service">
      <p className="legal-document__updated">Last updated: March 2026</p>

      <p>
        These Terms of Service (“Terms”) govern your access to and use of Back to School Forms (the “Service”), an
        application used by school districts for enrollment and related registration workflows. By using the Service,
        you agree to these Terms. If you do not agree, do not use the Service.
      </p>

      <h2>The Service</h2>
      <p>
        The Service allows authorized users (such as parents, guardians, and district staff) to complete and manage
        forms and submissions in connection with student enrollment and district operations. Features and availability
        are determined in part by your school district’s configuration.
      </p>

      <h2>Your account and accuracy of information</h2>
      <p>
        You are responsible for maintaining the confidentiality of your account credentials and for all activity
        under your account. You agree to provide accurate, current, and complete information on forms and to update it
        when it changes. You may not use another person’s account without permission or use the Service for any
        unlawful purpose.
      </p>

      <h2>District relationship</h2>
      <p>
        Your school district decides which forms are required, how data is used within the district, and how long
        records are retained under district policy and applicable law. The district’s own policies may apply in
        addition to these Terms.
      </p>

      <h2>Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Attempt to gain unauthorized access to the Service, other users’ data, or underlying systems</li>
        <li>Interfere with or disrupt the Service or servers or networks connected to the Service</li>
        <li>Use automated means to access the Service in a manner that imposes an unreasonable load or violates security</li>
        <li>Upload malware or content that is illegal, harassing, or infringes others’ rights</li>
      </ul>

      <h2>Intellectual property</h2>
      <p>
        The Service, including its software, design, and branding (excluding content you or your district provide),
        is owned by us or our licensors and is protected by applicable intellectual property laws. We grant you a
        limited, non-exclusive, non-transferable right to use the Service as offered to you by your district.
      </p>

      <h2>Disclaimer</h2>
      <p>
        THE SERVICE IS PROVIDED “AS IS” AND “AS AVAILABLE.” TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE DISCLAIM ALL
        WARRANTIES, WHETHER EXPRESS OR IMPLIED, INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
        PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED OR
        ERROR-FREE.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT WILL WE OR OUR SUPPLIERS BE LIABLE FOR ANY INDIRECT,
        INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR DATA, ARISING OUT OF OR
        IN CONNECTION WITH YOUR USE OF THE SERVICE, WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE),
        OR ANY OTHER LEGAL THEORY, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. OUR TOTAL LIABILITY
        FOR CLAIMS ARISING OUT OF OR RELATED TO THE SERVICE IS LIMITED TO THE GREATER OF ONE HUNDRED U.S. DOLLARS
        (US $100) OR THE AMOUNTS YOU PAID US FOR THE SERVICE IN THE TWELVE MONTHS BEFORE THE CLAIM (IF ANY). SOME
        JURISDICTIONS DO NOT ALLOW CERTAIN LIMITATIONS; IN THOSE JURISDICTIONS, OUR LIABILITY WILL BE LIMITED TO THE
        MAXIMUM EXTENT PERMITTED BY LAW.
      </p>

      <h2>Privacy</h2>
      <p>
        Our collection and use of personal information is described in our{' '}
        <Link to="/privacy-policy">Privacy Policy</Link>. We do not sell your personal information.
      </p>

      <h2>Changes</h2>
      <p>
        We may modify these Terms at any time by posting the updated Terms on this page and updating the “Last
        updated” date. Your continued use of the Service after changes become effective constitutes acceptance of the
        revised Terms. If you do not agree, you must stop using the Service.
      </p>

      <h2>Termination</h2>
      <p>
        We may suspend or terminate access to the Service if you violate these Terms or if required for legal,
        security, or operational reasons. Your district may also control access to district-specific features.
      </p>

      <h2>Contact</h2>
      <p>
        For account, enrollment, or data questions, contact your school district’s administrator. For questions about
        these Terms, use the contact method your district provides for this service.
      </p>
    </LegalDocumentLayout>
  );
};

export default TermsOfService;
